module.exports = __webpack_public_path__ + "media/images/tailwind/question-mark-circle-1cf2b9c8a7b41c3957e5863ca2d8745d.png";